import { Field, FieldProps } from '@atlaskit/form';
import { Meta } from '@atlaskit/form/Field';
import * as React from 'react';
import { transformToCurrency } from '@atlassian/cssxp-utils-generic';

export type Props = Omit<
  React.ComponentProps<typeof Field>,
  'transform' | 'children' | 'isDisabled' | 'defaultValue'
> & {
  currency?: string | null;
  transform?: (event: React.FormEvent<HTMLInputElement> | string, current: string) => string;
  children: (args: {
    fieldProps: FieldProps<string, HTMLInputElement>;
    error?: string;
    valid: boolean;
    meta: Meta;
  }) => React.ReactNode;
  defaultValue?: string;
  isDisabled?: boolean;
};

const CurrencyField = (props: Props) => {
  const {
    // Allow users to transform the value before transforming to the respected currency
    // If a dev needs to transform the currency in a different way, an additional transformer could be added
    transform: preCurrencyTransform,
    currency,
    children,
    defaultValue = undefined,
    isDisabled = false,
    ...otherProps
  } = props;

  const fieldProps = {
    defaultValue,
    isDisabled,
    ...otherProps,
  };

  return (
    <Field<string, HTMLInputElement>
      {...fieldProps}
      // @ts-ignore
      transform={(event: React.ChangeEvent<HTMLInputElement>, current: string) => {
        let currentValue = event.currentTarget.value;
        if (preCurrencyTransform) {
          currentValue = preCurrencyTransform(event, current);
        }
        return transformToCurrency(currentValue, currency);
      }}
      isDisabled={false}
    >
      {children}
    </Field>
  );
};

export default CurrencyField;
